import { ChangeEvent, useState } from 'react';
import { TextField, Widget } from '../../../components';
import { useStore } from '../../../store';

export default function ApiWidget() {
  const store = useStore();
  const [apiUrl, setApiUrl] = useState('https://api.pulsedownloader.com/api');

  function onChange(e: ChangeEvent<HTMLInputElement>) {
    const newApiUrl = e.target.value.trim();
    setApiUrl(newApiUrl);
    store.setBaseApiUrl(newApiUrl);
  }

  return (
    <Widget surface="gray" title="Customize Install Dialog">
      <TextField
        label="API URL"
        name="apiUrl"
        onChange={onChange}
        value={apiUrl}
      />
    </Widget>
  );
}
